import React from 'react'
import { theme } from './utils/theme'
import { ChakraProvider } from '@chakra-ui/react'
import { createRoot } from 'react-dom/client'
import Router from './navigation/Router'
import '@fontsource/montserrat'
const container = document.getElementById('root')
const root = createRoot(container) // createRoot(container!) if you use TypeScript
root.render(
  <ChakraProvider theme={theme}>
    <Router />
  </ChakraProvider>,
)
